import Vue from 'vue'
import GoogleMapsApiLoader from 'google-maps-api-loader'

Vue.prototype.$loadGmap = function () {
    if (Vue.$google) {
        return Promise.resolve()
    } else {
        return GoogleMapsApiLoader({
            apiKey: process.env.VUE_APP_MAPS_KEY
        }).then(google => {
            Vue.prototype.$google = google
        })
    }
}
